import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../components/Shared/Card';
import { EmptyState } from '../../../components/Shared/EmptyState';
import { ReleaseNoteEntry } from '../../../components/Shared/ReleaseNoteEntry';
import { useVisibleReleaseNotes } from '../../../hooks/useVisibleReleaseNotes';
import { formatDate } from '../../../utils/dateUtils';

export default function ReleaseNotesPage() {
  const { t } = useTranslation('releaseNotes');
  const { notes, markAllSeen } = useVisibleReleaseNotes();

  // Wer die Historie öffnet, hat die Neuerungen gesehen — der Hinweispunkt im
  // Benutzermenü verschwindet damit.
  useEffect(() => {
    markAllSeen();
  }, [markAllSeen]);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">
          {t('page.title')}
        </h1>
        <p className="text-[13px] text-slate-500 mt-1">{t('page.subtitle')}</p>
      </div>

      {notes.length === 0 ? (
        <EmptyState title={t('page.empty')} />
      ) : (
        <div className="space-y-4">
          {notes.map((note) => (
            <Card key={note.version}>
              <div className="space-y-3">
                <div className="flex items-baseline justify-between gap-3 flex-wrap">
                  <h2 className="text-[15px] font-semibold text-slate-900 tracking-tight">
                    {note.title}
                  </h2>
                  <span className="text-[11px] font-mono tabular-nums text-slate-500">
                    {t('meta', { version: note.version, date: formatDate(note.date) })}
                  </span>
                </div>
                <ReleaseNoteEntry note={note} hideMeta />
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
